import { documentMaskUtils } from 'components/SignUp/data'

export function getFormattedValue(value?: string, mask: string = documentMaskUtils.mask, placeholder: string = '_') {
  if (!value) return ''

  let output = ''
  let inputIndex = 0

  for (let i = 0; i < mask.length; i += 1) {
    const currentChar = mask[i]

    if (!value.length) {
      output += ''
      break
    }
    if (currentChar === placeholder) {
      if (inputIndex < value.length) {
        output += value[inputIndex]
        inputIndex += 1
      } else {
        break
      }
    } else if (output.replace(/[^\d]/g, '') === value) {
      break
    } else {
      output += currentChar
    }
  }

  return output
}
